import { useTransaction } from '#/containers/PropertyDetail/hooks/useTransactions'
import { OnDetail } from '../../types'
import MLSDetails from '../MLSDetails'
import PublicRecords from '../PublicRecords'
import PropertyDetailsSkeleton from '../PublicRecords/Skeleton'
import { Section } from '../common'

type Props = {
  loading: boolean
  mls?: TopHap.PropertiesState['mls']
  property: TopHap.ExtendedProperty
  authenticated: boolean
  history?: TopHap.PropertyTransaction[]
  publicRecord?: TopHap.Service.GetPublicRecordResponse | null
  onDetail: OnDetail
}

const PropertyDetails: React.FC<Props> = ({
  property,
  publicRecord,
  history,
  loading,
  ...props
}) => {
  const rets = useTransaction(history || [], 'Listing') as TopHap.ListingTransaction | undefined

  if (!loading && !publicRecord && !rets) return null

  const sections = history ?
    [rets && 'MLS Details', publicRecord && 'Public Records'].filter(e => e) :
    ['MLS Details', 'Public Records']

  return (
    <Section
      description={`${sections.join(' and ')} for ${property.displayAddress}`}
      id='property_details'
      mode='Carousel'
      title='Property Details'
    >
      {!loading ? (
        <>
          <MLSDetails
            className='inline-flex w-80 snap-center flex-col align-top'
            property={property}
            rets={rets}
            {...props}
          />
          <div className='inline-flex w-80 snap-center overflow-hidden rounded-xl bg-white align-top shadow-md'>
            <PublicRecords publicRecord={publicRecord} {...props} />
          </div>
        </>
      ) :
        <PropertyDetailsSkeleton />}
    </Section>
  )
}

export default PropertyDetails
